import { forwardRef, PopoverContent, PopoverContentProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export const MonthSelectorPopup = forwardRef<PropsWithChildren & PopoverContentProps, 'div'>(({ children, ...rest }, ref) => {
	return (
		<PopoverContent minW="auto" ref={ref} {...rest}>
			{children}
		</PopoverContent>
	);
});

MonthSelectorPopup.displayName = 'MonthSelectorPopup';
